// Copyright (c) 2021 Deere & Company

import MassLaborRates from '../state/mass-labor-rates';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const setMassLaborRates = (state, action) =>
    MassLaborRates.update(state, {
        $set: action.data
    });
const updateRequestedRate = (state, action) => {

    const updatedLaborRateList = state.filter(account => {

        const updatedAccount = account.rates.map(rate => {

            if (action.index === rate.description) {

                if ((action.rate === 0 || action.rate === null) && (!action.requestId)) {

                    rate.requestedRate = rate.currentRate;

                } else {

                    rate.requestedRate = action.rate;

                }

            }

            return account;

        });

        return updatedAccount;

    });

    return MassLaborRates.update(state, {
        $set: updatedLaborRateList
    });

};

const updateEffectiveDate = (state, action) => {

    const updatedLaborRateList = state.map(account => {

        account.effectiveDate = action.effectiveDate;
        return account;

    });

    return MassLaborRates.update(state, {
        $set: updatedLaborRateList
    });

};
const updateAverageTechPayRate = (state, action) => {

    const updatedLaborRateList = state.map(account => {

        account.averageTechPayRate = action.rate;
        return account;

    });

    return MassLaborRates.update(state, {
        $set: updatedLaborRateList
    });

};

const updateComment = (state, action) => {

    const updatedLaborRateList = state.filter(account => {

        const updatedAccount = account.rates.map(rate => {

            if (action.index === rate.description) {

                rate.reasonForChange = action.comment;

            }

            return account;

        });

        return updatedAccount;

    });

    return MassLaborRates.update(state, {
        $set: updatedLaborRateList
    });

};

const updateFile = (state, action) => {

    const updatedLaborRateList = state.map(account => {

        account.file = action.file;
        return account;

    });

    return MassLaborRates.update(state, {
        $set: updatedLaborRateList
    });

};

const resetClaimDealersDetails = state =>

    MassLaborRates.update(state, {
        $set: []
    });

export default (state = getDefaultState().dealersByLaborType, action) => {

    const actionTypes = {
        [actions.SET_SELECTED_ACCOUNT_LABOR_RATES]: setMassLaborRates,
        [actions.UPDATE_MASS_LABOR_RATE_REQUESTED_RATE]: updateRequestedRate,
        [actions.UPDATE_MASS_LABOR_RATE_COMMENT]: updateComment,
        [actions.UPDATE_MASS_LABOR_RATE_FILE]: updateFile,
        [actions.UPDATE_MASS_LABOR_RATE_EFFECTIVE_DATE]: updateEffectiveDate,
        [actions.UPDATE_MASS_LABOR_RATE_AVERAGE_TECH_PAY_RATE]: updateAverageTechPayRate,
        [actions.RESET_CLAIM_DEALER_DETAILS]: resetClaimDealersDetails
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/reducers/mass-labor-rate.js